import React, { Component } from 'react';
import FieldLevelHelp from './components/FieldLevelHelp';
import PatientMatch from './patient/PatientMatch';
import AlertMessage from './AlertMessage';
import { scrollToMessage } from './util/scrollToMessage';
import RequiredFieldDisclaimer from './components/RequiredFieldDisclaimer';
import withWorkflow from './components/withWorkflow';
import { putPatientInfo, fetchInsuranceListByPatientDetails } from './util/apiUtils';
import PostOfficeBoxPrompt from './components/PostOfficeBoxPrompt';
import { calculateAge, getDateFromIso8601String } from './components/DatePicker';
import { isCanadianClient, isGovernmentPayorOrder } from './util/gearOrderUtil';
import MedicareOrderAlert from './components/MedicareOrderAlert';
import AccessionedOrderAlert from './components/AccessionedOrderAlert';
import Modal from './components/Modal';
import ShippingMethodSelection from './components/shipping-method/ShippingMethodSelection';
import {
	buildPatientInfoFormFromOrder,
	formatInitialPhoneNumber,
	formatPhoneNumberForSave,
	validatePatientInfoForm,
	employerStates,
	shippingMethods,
	validStates,
	validPitlStates
} from './patient/PatientInfoForm';
import { mapCountry } from './components/CountrySelect';
import DateOfBirthInput from './components/DateOfBirthInput';
import PhoneInput from 'react-phone-number-input/input';
import AddressInputForm from './patient/AddressInputForm';
import ConnectRememberMe from './phsycian-in-the-loop/rememberMeUtil';

class PatientInfo extends Component {

	constructor(props) {
		super(props);

		this.shippingMethods = shippingMethods;

		let shippingAddress = {};
		let employerAddress = {};
		let patientInfo = {};
		let showEmployer = false;

		if (this.props.gearOrder !== null) {
			patientInfo = Object.assign({}, this.props.gearOrder.patientInfo);
			if (patientInfo && patientInfo.addresses) {
				for (let i = 0; i < patientInfo.addresses.length; i++) {
					if (patientInfo.addresses[i].type === 'shipping') shippingAddress = { ...patientInfo.addresses[i] };
					if (patientInfo.addresses[i].type === 'employer') employerAddress = patientInfo.addresses[i];
				}
			}

			if (shippingAddress){
                showEmployer = employerStates.indexOf(shippingAddress.state) > -1;
			}
        }

		let isMinor = false;
		if (this.props.gearOrder && this.props.gearOrder.patientInfo) {
			let dob = new Date(this.props.gearOrder.patientInfo.dateOfBirth);
			isMinor = calculateAge(dob) < 18;
		}

		// SCR-6308: Lock the page if any requisition on the order has been accessioned
		const locked = this.props.userInfo.adminUser !== 'true' && this.props.gearOrder && this.props.gearOrder.requisitions && this.props.gearOrder.requisitions.some(req => req.accessionNo);
		
		let confirmed = false;
		// SCR-6308: Do not allow the last name to be changed after the order is confirmed
		if( this.props.userInfo.adminUser !== 'true' ) {
			// If this is a 'myGDX' user lock down the page if practitioner confirm step and this step are completed
			// This allows the practitioner to continue editing the page if the patient decides not to
			if( this.props.userInfo.type === 'myGDX' ) {
				let practConfirmStep = this.props.getWorkflowStep('practitioner_confirmation');
				let patientInfoStep = this.props.getWorkflowStep('patient');
				confirmed = practConfirmStep && practConfirmStep.completed && patientInfoStep && patientInfoStep.completed;
			} else {
				 // For 'prc' users lock down the page if the patient confirm step is completed or if the entire requisition is complete
				 let patientConfirmStep = this.props.getWorkflowStep('patient_confirmation');
				 confirmed = (patientConfirmStep && patientConfirmStep.completed) || (this.props.gearOrder.workflow && this.props.gearOrder.workflow.complete);
			}
		}

		// SCR-6630: Do not allow any address changes if the order contains a confirmed drop-ship requisition
		const addressLocked = this.props.userInfo.adminUser !== 'true'
			&& this.props.userInfo.type === 'myGDX'
			&& this.props.gearOrder.containsDropShipRequisition
			&& this.props.getWorkflowStep('practitioner_confirmation')?.completed;
		
		let form = buildPatientInfoFormFromOrder(this.props.gearOrder);
		let employmentStatus = "Employed";
		if (this.props.gearOrder) {
			if (this.props.gearOrder.patientInfo && this.props.gearOrder.patientInfo.occupation) {
				if (this.props.gearOrder.patientInfo.occupation === "Unemployed" || this.props.gearOrder.patientInfo.occupation === "Student"  || this.props.gearOrder.patientInfo.occupation === "Retired") {
					employmentStatus = this.props.gearOrder.patientInfo.occupation;
				}
			}
		}
		if (shippingAddress && !shippingAddress.country && this.props.gearOrder.containsDropShipRequisition) {
			shippingAddress.country = this.props.gearOrder.practitioner.office.address.country;
		}

		this.state = {
			showError: this.props.showError,
			errorMessage: this.props.errorMessage,
			employerRequired: showEmployer,
			employerStates: employerStates,
			isMinor: isMinor,
			shippingAddress: shippingAddress,
			patientInfo: patientInfo,
			employerAddress: employerAddress,
			matchingPatient: null,
			numMatches: 0,
			showMatches: false,
			searchTimeout: false,
			noMatchesFound: false,
			pageLocked: locked,
			addressLocked: addressLocked,
			pageConfirmed: confirmed,
			form: form,
			selectedPatientMatchKey: null,
			showPoBoxDialog: false,
			poBox: null,
			covidRegistration: this.props.gearOrder.containsCovidRegistration,
			employmentStatus: employmentStatus,
			employerRequiredFlag: !this.props.gearOrder.containsDropShipRequisition && showEmployer
			&& this.props.gearOrder?.patientInfo?.occupation !== 'Retired',
			dobConfirmationValue: null,
			invalidPhysicianInTheLoopState: false,
			nutritionalAgeRestriction: false,
			manualAddressInput: false
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.submitPatientInfo = this.submitPatientInfo.bind(this);
		this.goBack = this.goBack.bind(this);
		this.searchAndLookupKeyPressHandler = this.searchAndLookupKeyPressHandler.bind(this);
		this.searchPatients = this.searchPatients.bind(this);
		this.lookupPatient = this.lookupPatient.bind(this);
		this.findPatients = this.findPatients.bind(this);
		this.setFormValue = this.setFormValue.bind(this);
		this.scrollToPatientInfo = this.scrollToPatientInfo.bind(this);

		this.validStates = validStates;
	}
	goBack(e) {
		if (this.props.doConfirm(e)) {
			this.props.updateStep(this.props.gearOrder, 'patient', 'Back');
		} else {
			e.preventDefault();
		}
	}
	componentDidMount() {
		if (this.props.editRef) {
			this.props.editRef({
				save: this.submitPatientInfo,
				reset: () => {},
				isDirty: () => !!this.state.dirty
			});
		}
		var inputs = document.getElementsByTagName('input');
		for (var i = 0; i < inputs.length; i++) {
			var input = inputs[i];
			if (this.state.pageLocked) {
				input.disabled = true;
			}
		}
	}
	componentDidUpdate(prevProps){
        if ( this.props.errorMessage !== prevProps.errorMessage ) {
            this.setState({
                showError: this.props.showError,
                errorMessage: this.props.errorMessage
            });
			// Scroll up so the error is visible
			window.scrollTo(0, 0);
        }
	}

	setDirty = (value) => {
		this.setState({dirty: value});
		this.props.setDirty(value);
	}

	/**
	 * Validate the form data and, if all fields are valid, submit the details.
	 */
	submitPatientInfo() {
		const validatedForm = this.validate(this.state.form);
		const isValid = Object.values(validatedForm).every(prop => prop.valid);

		this.setState(
			{
				form: validatedForm
			},
			() => {
				if (!isValid) {
					scrollToMessage();
				}
			}
		);

		if (isValid) {
			const shippingAddress = {
				type: "shipping",
				address1: this.state.form.address1?.value,
				address2: this.state.form.address2?.value,
				alternatePhone: formatPhoneNumberForSave(this.state.form.alternatePhone?.value),
				city: this.state.form.city?.value,
				country: this.state.form.country?.value,
				county: this.state.form.county?.value,
				state: this.state.form.state?.value,
				voicePhone: formatPhoneNumberForSave(this.state.form.voicePhone?.value),
				zipCode: this.state.form.zipCode?.value
			}
	
			var patientEmployerAddress = document.getElementsByName('employerAddress');
			var employerAddress = {};
	
			var i;
			for (i = patientEmployerAddress.length - 1; i >= 0; --i) {
				employerAddress[patientEmployerAddress[i].id.replace("employer-", "")] = patientEmployerAddress[i].value;
			}
			employerAddress['type'] = 'employer';
			employerAddress.voicePhone = formatPhoneNumberForSave(this.state.form.employerVoicePhone?.value);
	
			var patientInfoElements = document.getElementsByClassName('patientInfo');
			var patientInfo = {};
			for (i = patientInfoElements.length - 1; i >= 0; --i) {
				let fieldKey = patientInfoElements[i].id.replace("patient-", "");
				if (fieldKey === 'marketingOptIn') {
					patientInfo[fieldKey] = patientInfoElements[i].checked;
				} else {
					patientInfo[fieldKey] = patientInfoElements[i].value;
				}
			}
	
			// The MarketingOptIn checkbox is only shown to 'prc' users. For any other user type, use the original value from the GearOrder.
			if (this.props.userInfo.type !== 'prc') {
				patientInfo.marketingOptIn = !!this.props.gearOrder.patientInfo?.marketingOptIn;
			}
	
			var radios = document.getElementsByName('gender');
			for (i = 0; i < radios.length; i++) {
				if (radios[i].checked) {
					patientInfo.gender = radios[i].value;
					break;
				}
			}
	
			var addresses = [shippingAddress];
			if (this.state.employerRequired) {
				addresses.push(employerAddress);
			}
			if	(this.state.employmentStatus && this.state.employmentStatus !== 'Employed') {
				patientInfo.occupation = this.state.form.occupation.value;
			}
			patientInfo['addresses'] = addresses;
			patientInfo.dateOfBirth = this.state.form.dateOfBirth.value;
			const updatedGearOrder = Object.assign({}, this.props.gearOrder);
			updatedGearOrder.patientInfo = patientInfo;
			updatedGearOrder.shippingMethod = this.state.form.shippingMethod.value;
	
			// Use the passed in updatePatientInfo method if available (Used by PITLTransfer)
			if (this.props.updatePatientInfo) {
				return this.props.updatePatientInfo(updatedGearOrder);	
			}
			return this.updatePatientInfo(updatedGearOrder, 'Next');
			
		} else {
			if (this.props.editRef) {
				return Promise.reject('ValidationError');
			}
		}
	}

	/**
	 * Submit the updated details and handle the response.
	 * If the update was successful, redirect to the next step.
	 * If the update failed, show an error message.
	 * 
	 * @param gearOrder The order containing updated details to submit
	 */
	updatePatientInfo = (gearOrder) => {
		this.props.setLoading(true);
		return putPatientInfo(gearOrder)
			.then(json => {
				this.props.setLoading(false);
				if (json.id) {
					this.props.setGearOrder(json);

					// if MarketingOptIn checkbox is true, add current patient's email to the subscriber list
					if (json?.patientInfo?.marketingOptIn && this.props.userInfo.type === 'prc') {
						this.submitPatientForMarketing(json);
					}

					// Store PITL order details in localstorage to allow the patient to return to this order if they browse away from Gear
					if (json?.physicianInTheLoop) {
						ConnectRememberMe.storeValue(json);
					}

					this.setDirty(false);
					this.props.updateStep(json, 'patient', 'Next');
					return Promise.resolve(json);
				} else if (json.errors) {
					this.setState({
						showError: true,
						errorMessage: json.errors[0].field + ' ' + json.errors[0].defaultMessage
					});

					if (this.props.editRef) {
						return Promise.reject('an unexpected error has occurred. please call us at 800-522-4762.');
					} else {
						// Scroll up so the error is visible
						window.scrollTo(0, 0);
					}
				}
			})
			.catch(e => {
				this.props.setLoading(false);
				if (e.response && e.response.status === 400) {
					e.response.json().then(json => {
						this.setState({
							showError: true,
							errorMessage: json
						});
					});
				} else {
					this.setState({
						showError: true,
						errorMessage: 'The network is currently unavailable. Please call us at 800-522-4762.'
					});
				}

				if (this.props.editRef) {
					return Promise.reject();
				} else {
					// Scroll up so the error is visible
					window.scrollTo(0, 0);
				}
			});
	}

	/**
	 * On form submission either redirect to the next step if nothing needs to be saved
	 * or validate and save the data.
	 *
	 * @param {Event} event 
	 */
	handleSubmit(event) {
		event?.preventDefault && event.preventDefault();

		if (this.state.pageLocked) {
			this.props.updateStep(this.props.gearOrder, 'patient', 'Next');
		} else if (this.props.editRef && this.props.triggerInlineSave) {
			this.props.triggerInlineSave();
		} else {
			this.submitPatientInfo();
		}
	}

	/**
	 * Check if either of the address fields contain a P.O. Box.
	 * We don't need to check if the shipping method is 'Smart Post' because Smart Post is what
	 * we want to use for PO Box shipping.
	 * 
	 * Regex explaination:
	 * 	(P|POST) - Contains the letter 'P' or the word 'POST'
	 * 	[.\s]* - 0 or more periods or spaces
	 * 	(O|OFFICE) - Contains the letter 'O' or the word 'OFFICE'
	 * 	BOX - Contains the word 'BOX'
	 * 	Flags:
	 * 		g - global search (find all matches rather than stopping after the first match)
	 * 		i - Case insensitive
	 * 
	 * @return true if either address is a PO Box, false otherwise
	 */
	hasPOBox = (address1, address2) => {
		// Do not check for PO Box for Canadaian clients
		if (isCanadianClient(this.props.gearOrder)) {
			return false;
		}
		const poBoxRegex = /(P|POST)[.\s]*(O|OFFICE)[.\s]*BOX/gi;
		return this.state.form.shippingMethod.value !== this.shippingMethods.SMART_POST && (poBoxRegex.test(address1) || poBoxRegex.test(address2));
	}

	/**
	 * Handle the 'Yes' choice from the PO Box dialog.
	 * Sets the shipping method to 'Smart Post', flags that we have handled the PO Box scenario,
	 *  and attempts to submit the patient data.
	 * The data will be revalidated in case there are other fields that are invalid.
	 */
	affirmPoBox = () => {
		let form = Object.assign({}, this.state.form);
		form.shippingMethod.value = this.shippingMethods.SMART_POST;
		this.setState({
			form: form,
			poBox: true
		}, () => {
			// Try to submit the info again now that we have handled the PO Box case.
			// This will revalidate all fields
			this.handleSubmit();
		});
	}

	/**
	 * Handle the 'No' choice from the PO Box dialog.
	 * Set the 'poBox' flag to indicate that we have handled the PO Box scenario and
	 *  attempt to submit the patient data.
	 * The data will be revalidated in case there are other fields that are invalid.
	 */
	denyPoBox = () => {
		this.setState({
			poBox: false
		}, () => {
			// Try to submit the info again now that we have handled the PO Box case.
			// This will revalidate all fields
			this.handleSubmit();
		});
	}

	checkState(addrState) {
		if (addrState) {
			var employerStates = this.state.employerStates;
			this.setState({employerRequired: employerStates.includes(addrState.toUpperCase())});
			return;
		}
		this.setState({employerRequired: false});

	}

	/**
	 * Handles the datepicker input change.
	 * 
	 * @param date The entered Date in ISO 8601 format (yyyy-mm-dd)
	 */
	dobHandler = (date) => {
		this.checkAge(date);

		let age;
		if (date !== this.state.form.dateOfBirth.value) {
			this.setDirty(true);
			let form = Object.assign({}, this.state.form);

			// Clear previous validation when a new date is entered
			form.dateOfBirth = {
				value: date
			}
			age = calculateAge(getDateFromIso8601String(date)) ?? '';
			form.age.value = age;
			this.setState({
				form: form
			});

			this.isNutritionalAgeRestriction(date);
		}
	}
	checkAge(dob) {
		if (!dob) {
			return;	
		}

		let isMinor = calculateAge( getDateFromIso8601String( dob ) ) < 18;
		this.setState({ isMinor: isMinor });
	}

	/**
	 * Checks if the age is less than 2, product is nutritional, and the order is PITL or cap-authorized.
	 * 
	 * @param date The Date in ISO 8601 format (yyyy-mm-dd)
	 * @return true if the age is not valid, false otherwise
	 */
	isNutritionalAgeRestriction = (date) => {
		if (!date) {
			return false;
		}
		const age = calculateAge(getDateFromIso8601String(date)) ?? '';
		if ((this.props.gearOrder?.physicianInTheLoop || this.props.gearOrder?.practitioner?.capAuthorized) &&
			age < 2 &&
			this.props.gearOrder?.requisitions?.some(
				(req) => req.omsOrderableItemCategory?.toLowerCase() === 'nutritional'
			)
		) {
			this.setState({
				nutritionalAgeRestriction: true
			});
			return true;
		} else {
			this.setState({
				nutritionalAgeRestriction: false
			});
		}
		return false;
	}

	/**
	 * Handles key presses in the patient search and lookup inputs. Since all inputs are in a single form, do not submit
	 * the form if the enter key is pressed in the search or lookup inputs. Instead, simply search for or lookup the
	 * patient.
	 */
	searchAndLookupKeyPressHandler(event) {
		if (event.which === 13) {
			event.stopPropagation();
			event.preventDefault();
			if (event.target.id === "patient-query") {
				this.searchPatients();
			} else if (event.target.id === "patient-lookup") {
				this.lookupPatient();
			}
		}
	}

	submitPatientForMarketing(gearOrder) {
		let pauboxListId = gearOrder?.physicianInTheLoop ? "cafdc662-31cd-431c-9ccd-ce4cc8ea3aae" : "9edc5d39-c4a7-45cb-8f55-6f981316228f";

		let formData = new FormData();
		formData.append('email', gearOrder?.patientInfo.email);
		formData.append('first_name', gearOrder?.patientInfo.nameFirst);
		formData.append('gender', gearOrder?.patientInfo.gender);
		formData.append('age', calculateAge(getDateFromIso8601String(gearOrder?.patientInfo.dateOfBirth)));
		formData.append('subscription_list_id', pauboxListId);
		// The website requires a CSRF token. Graph the token from the page's meta attributes
		formData.append('_csrf', document.querySelector('meta[name="_csrf"]').content);
		// Use the original window.fetch when calling gdx_web_url so we don't include the access-token header
		window._fetch(`${process.env.REACT_APP_GDX_WEB_URL}/subscribe`, {
			mode: 'cors',
			credentials: 'include',
			method: 'post',
			timeout: 1000,
			body: formData
		})
		.then((response) => {
			if (response.ok) {
				return response.json();
			}
			return Promise.reject('unexpected');
		})
		.catch((error) => {
			return error;
		});
	}

	/**
	 * Searches for patients by last name and optionally first name and/or date of birth.
	 */
	searchPatients() {
		let query = document.getElementById('patient-query').value;
		if (query) {
			this.findPatients(query, "");
		}
	}

	/**
	 * Looks up a patient by Ellkay chart number.
	 */
	lookupPatient() {
		let chartNumber = document.getElementById('patient-lookup').value;
		if (chartNumber) {
			this.findPatients("", chartNumber);
		}
	}

	/**
	 * Finds patients matching the query or chart number provided.
	 */
	findPatients(query, chartNumber) {
		this.props.setLoading(true);
		var timer = window.setTimeout(() => {
			this.setState({
				searchTimeout: true
			});
			this.props.setLoading(false);
		}, 30000);
		fetch(process.env.REACT_APP_GEAR_REST_URL + '/api/patient-lookup?chartNumber=' + chartNumber + '&query=' + query + '&orderId=' + this.props.gearOrder.id,
			{
				method: 'GET',
				credentials: 'include',
				mode: 'cors',
				timeout: 1000,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				}
			})
			.then(response => response.json())
			.then(json => {
				window.clearTimeout(timer);
				if (json.error) {
					this.setState({
						showError: true,
						errorMessage: json.message,
						numMatches: 0,
						matchingPatients: null,
						showMatches: false,
						noMatchesFound: false
					});
				} else {
					let numMatches = json.length;
					this.setState({
						numMatches: numMatches,
						matchingPatients: json,
						showMatches: true,
						noMatchesFound: numMatches === 0
					});
				}
				this.props.setLoading(false);
				this.setState({
					searchTimeout: false
				});
			})
			.catch(error => {
				this.setState({
					showError: true,
					errorMessage: 'Error searching for patient matches.',
					searchTimeout: false
				});
				console.log('Patient search failed', error);
				this.props.setLoading(false);
			});
	}

	toggleMatches() {
		this.setState({ showMatches: !this.state.showMatches });
	}
	handleShippingChange(propertyName, e) {
		this.setDirty(true);

		var shippingAddress = this.state.shippingAddress;
		if (!shippingAddress) { shippingAddress = { type: 'shipping' }; }

		// The PhoneInput component passes in the value directly so use 'e' as-is if e.target does not exist
		let value = e?.target ? e.target.value : e;

		shippingAddress[propertyName] = value;
		let form = Object.assign({}, this.state.form);
		form[propertyName].value = value;

		// SCR-8097: Reset the shipping method to 'FedEx Ground' when Canada is selected
		if (propertyName === 'country' && value === 'Canada') {
			form.shippingMethod = {
				value: 'FedEx Ground'
			}
		}

		this.setState({ 
			shippingAddress: shippingAddress,
			form: form
		 });
		if (propertyName === 'state' && value.length === 2) {
			this.checkState(shippingAddress.state)

			if (this.props.gearOrder?.physicianInTheLoop || this.props.gearOrder?.practitioner?.capAuthorized) {
				if (!validPitlStates.includes(value.toUpperCase())) {
					this.setState({
						invalidPhysicianInTheLoopState : true
					})
				} else {
					this.setState({
						invalidPhysicianInTheLoopState : false
					})
				}
			}
		}
	}
	handleEmployerAddChange(propertyName, e) {
		this.setDirty(true);

		var employerAddress = this.state.employerAddress;
		if (!employerAddress) { employerAddress = { type: 'employer' }; }

		// The PhoneInput component passes in the value directly so use 'e' as-is if e.target does not exist
		let value = e?.target ? e.target.value : e;

		employerAddress[propertyName] = value;
		let form = Object.assign({}, this.state.form);
		form["employer" + propertyName.charAt(0).toUpperCase() + propertyName.slice(1)].value = value;
		this.setState({ 
			employerAddress: employerAddress,
			form: form 
		});
	}
	handlePatientInfoChange(propertyName, e) {
		let patientInfo = this.state.patientInfo;
		if (!patientInfo) { patientInfo = {}; }
		patientInfo[propertyName] = e.target.value;
		let form = Object.assign({}, this.state.form);
		form[propertyName].value = e.target.value;
		this.setState({ 
			patientInfo: patientInfo,
		 	form: form
		});
	}
	handleEmploymentStatusChange(propertyName, e) {
		
		let occupation = e.target.value !== 'Employed' ? e.target.value : '';
		let patientInfo = this.state.patientInfo;
		if (!patientInfo) { patientInfo = {}; }
		patientInfo['occupation'] = occupation;
		let form = Object.assign({}, this.state.form);
		form['occupation'].value = occupation;
		form['employmentStatus'].value = e.target.value;
		var event = { target: { value: null }};
		if(occupation === 'Retired' || occupation === 'Unemployed') {		
			this.handlePatientInfoChange('employer', event);
			this.handleEmployerAddChange('address1', event);
			this.handleEmployerAddChange('address2', event);
			this.handleEmployerAddChange('city', event);
			this.handleEmployerAddChange('state', event);
			this.handleEmployerAddChange('zipCode', event);
			this.handleEmployerAddChange('voicePhone', event);
			this.handleEmployerAddChange('schoolDistrict', event);
		}
		
		this.setState({ 
			patientInfo: patientInfo,
			form: form,
			employmentStatus: e.target.value,
			employerRequiredFlag: !this.props.gearOrder.containsDropShipRequisition && this.state.employerRequired && (e.target.value === 'Student' || e.target.value === 'Employed') ? true : false
		});
		this.validate(form);
		
	}
	selectPatient(patient) {
		this.setState({
			selectedPatientMatchKey: patient.matchKey
		});
		if (patient.source === "ELLKAY") {
			fetch(process.env.REACT_APP_GEAR_REST_URL
				+ '/api/get-ellkay-patient?chartNumber=' + patient.chartNumber + '&orderId=' + this.props.gearOrder.id, {
				method: 'GET',
				credentials: 'include',
				mode: 'cors',
				timeout: 1000,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				}
			})
			.then(response => response.json())
			.then(json => {
				if (json.error) {
					this.setState({
						showError: true,
						errorMessage: json.message,
						numMatches: 0,
						matchingPatients: null,
						showMatches: false
					});
				} else {
					this.populateInfo(json.patient);
					this.props.setInsuranceOptions(json.insurances);
				}
			})
			.catch(error => {
				this.setState({
					showError: true,
					errorMessage: 'Error searching for patient matches.'
				});
				console.log('Patient search failed', error);
			});
		} else {
			this.populateInfo(JSON.parse(JSON.stringify(patient))); // deep copy so altering form data does not change search result

			// If a 'GEAR' patient is selected and the order requires insurance, fetch previous insurances for the patient.
			if (patient.source === "GEAR") {
				let insuranceStep = this.props.getWorkflowStep('insurance');
				// Skip if insurance is not needed
				if (insuranceStep && insuranceStep.notApplicable) {
					return;
				}

				const gsdlNo = (this.props.gearOrder.practitioner || {}).gsdlNo;
				const nameFirst = patient.nameFirst;
				const nameLast = patient.nameLast;
				const dob = patient.dateOfBirth;
				fetchInsuranceListByPatientDetails(gsdlNo, nameLast, dob, nameFirst)
				.then(json => {
					if (json.error) {
						this.setState({
							showError: true,
							errorMessage: json.message,
							numMatches: 0,
							matchingPatients: null,
							showMatches: false
						});
					} else {
						/** 
						 * Only include the appropriate insurance options.
						 * Include Government insurance when we have a Government insurance order.
						 * Include Non-Government insurance when we have a commercial insurance order.
						 */
						const isMedicareOrder = isGovernmentPayorOrder(this.props.gearOrder);
						const validInsuranceList = json.filter(i => {
							const medicareInsurance = (i.insuranceProvider === 'medicare' || i.insuranceProvider === 'medicaid' || i.insuranceProvider === 'tricare' || i.insuranceProvider === 'medicare_railroad');
							return isMedicareOrder ? medicareInsurance : !medicareInsurance;
						})
						this.props.setInsuranceOptions(validInsuranceList);
					}
				})
				.catch(error => {
					this.setState({
						showError: true,
						errorMessage: 'Error searching for patient insurance.'
					});
					console.log('Insurance search failed', error);
				});
			}
			
		}
	}
	populateInfo(patient) {				
		let form = Object.assign({}, this.state.form);
		form.nameFirst.value = patient.nameFirst;
		form.nameLast.value = patient.nameLast;
		form.nameMiddle.value = patient.nameMiddle;
		form.dateOfBirth.value = patient.dateOfBirth;
		form.age.value = calculateAge( getDateFromIso8601String( patient.dateOfBirth ) ) 
		form.gender.value = patient.gender;
		form.driverLicenseNumber.value = patient.driverLicenseNumber;
		form.ssn.value = patient.ssn;
		form.race.value = patient.race;
		form.ethnicity.value = patient.ethnicity;
		form.responsibleNameFirst.value = patient.responsibleNameFirst;
		form.responsibleNameMiddle.value = patient.responsibleNameMiddle;
		form.responsibleNameLast.value = patient.responsibleNameLast;
		form.occupation.value = patient.occupation;
		form.employer.value = patient.employer;
		form.email.value = patient.email;
		form.chartNumber.value = patient.chartNumber;
		form.source.value = patient.source;
		let shipAddresses = patient.addresses.filter(addr => addr.type === 'shipping');
		let shipAddress = {};
		if (shipAddresses.length > 0) {
			shipAddress = shipAddresses[0];
			this.checkState(shipAddress.state);
			form.address1.value = shipAddress.address1;
			form.address2.value = shipAddress.address2;
			form.city.value = shipAddress.city;
			form.state.value = shipAddress.state;
			form.zipCode.value = shipAddress.zipCode;
			form.country.value = mapCountry(shipAddress.country);
			form.county.value = shipAddress.county;
			form.voicePhone.value = formatInitialPhoneNumber(shipAddress.voicePhone);
			form.alternatePhone.value = formatInitialPhoneNumber(shipAddress.alternatePhone);
		}
		
		let employmentStatus = "Employed";
		if (patient.occupation) {
			if (patient.occupation === "Unemployed" || patient.occupation === "Student"  || patient.occupation === "Retired") {
				employmentStatus = patient.occupation;
			}
		}	
		
		let empAddresses = patient.addresses.filter(addr => addr.type === 'employer');
		let empAddress = {};
		if (empAddresses.length > 0) {
			empAddress = empAddresses[0];
			this.checkState(empAddress.state);
			form.employerAddress1.value = empAddress.address1;
			form.employerAddress2.value = empAddress.address2;
			form.employerCity.value = empAddress.city;
			form.employerState.value = empAddress.state;
			form.employerZipCode.value = empAddress.zipCode;
			form.employerVoicePhone.value = empAddress.voicePhone;
		}

		/**
		 * Do full validation except skip the age confirmation.
		 * The confirmation will still happen when the page is submitted.
		 */
		form = this.validate(form, {bypassAgeConfirmation: true});

		this.setState({
			patientInfo: patient,
			shippingAddress: shipAddress,
			employerAddress: empAddress,
			employmentStatus: employmentStatus,
			form: form
		});
		let gender = patient.gender;
		document.getElementById('patientGenderMale').checked = gender === 'M';
		document.getElementById('patientGenderFemale').checked = gender === 'F';
		document.getElementById('patient-nameFirst').value = patient.nameFirst;
		document.getElementById('patient-nameMiddle').value = patient.nameMiddle;
		document.getElementById('patient-nameLast').value = patient.nameLast;
		document.getElementById('patient-email').value = patient.email;
		document.getElementById('patient-chartNumber').value = patient.chartNumber;

		this.scrollToPatientInfo();
	}
	
	setFormValue(e) {
		let form = Object.assign({}, this.state.form);
		form[e.currentTarget.dataset.fieldname].value = e.currentTarget.value;
		this.setState({ form: form });
	}
	
	validate(form, options) {
		let validatedForm = validatePatientInfoForm(form, this.props.gearOrder, (this.props.userInfo.type === 'prc' || this.props.gearOrder.physicianInTheLoop));

		// The validation method does not validate PO Box. Do that now.
		if (validatedForm?.address1?.valid) {
			if ( this.props.gearOrder.containsDropShipRequisition && this.state.poBox === null && this.hasPOBox(validatedForm.address1.value, null) ) {
				validatedForm.address1.valid = false;
				validatedForm.address1.message = 'Is this a P.O. Box?';
				// Create an address object to send to PostOfficeBoxPrompt
				let poBoxConfirmationAddress = {
					type: 'shipping',
					address1: validatedForm.address1.value,
					address2: validatedForm.address2.value,
					city: validatedForm.city.value,
					state: validatedForm.state.value,
					zip: validatedForm.zipCode.value
				};
				this.setState({ showPoBoxDialog: true, poBoxConfirmationAddress: poBoxConfirmationAddress });
			}
		}

		if ( this.props.gearOrder.containsDropShipRequisition && this.state.poBox === null && this.hasPOBox(validatedForm.address2.value, null) ) {
			validatedForm.address2.valid = false;
			validatedForm.address2.message = 'Is this a P.O. Box?';
			// Create an address object to send to PostOfficeBoxPrompt
			let poBoxConfirmationAddress = {
				type: 'shipping',
				address1: validatedForm.address1.value,
				address2: validatedForm.address2.value,
				city: validatedForm.city.value,
				state: validatedForm.state.value,
				zip: validatedForm.zipCode.value
			};
			this.setState({ showPoBoxDialog: true, poBoxConfirmationAddress: poBoxConfirmationAddress });
		}

		/**
		 * Do not trigger the age confirmation modal when options.bypassAgeConfirmation is true.
		 * 
		 * The age confirmation modal will auto-submit the page when the age is confirmed but we aren't
		 * always ready for the page to submit (like when we just loaded patient details from a search).
		 * Setting dateOfBirth.confirmedAge = null will prevent the modal from displaying.
		 */
		const bypassAgeConfirmation = options?.bypassAgeConfirmation;
		if (bypassAgeConfirmation && validatedForm.dateOfBirth.confirmedAge === false) {
			validatedForm.dateOfBirth.confirmedAge = null;
			validatedForm.dateOfBirth.message = '';
			validatedForm.dateOfBirth.valid = true;
		}

		if (this.isNutritionalAgeRestriction(validatedForm.dateOfBirth.value)) {
			validatedForm.dateOfBirth.valid = false;
		}
		
		return validatedForm;
	}
	
	/**
	 * Scroll the browser to the patient-info section.
	 */
	scrollToPatientInfo() {
		let patientInfo = document.querySelector("#patient-info");
		// Subtract 50 to make room for the website's floating header
		window.scroll({
			top: patientInfo.getBoundingClientRect().top + window.scrollY - 50, 
			left: 0, 
			behavior: 'smooth'
		});
	}

	/**
	 * Sets the state.form.dateOfBirth.confirmedAge value to true.
	 * This will close the confirmation Modal and allow an age of less than 1 year old.
	 */
	confirmDob = () => {
		if (this.state.dobConfirmationValue) {
			let updatedForm = Object.assign({}, this.state.form);
			updatedForm.dateOfBirth.confirmedAge = true;
			updatedForm.dateOfBirth.value = this.state.dobConfirmationValue;
			this.setState({ form: updatedForm, dobConfirmationValue: null }, this.handleSubmit);
		}
		return true;
	}

	/**
	 * Closes the DateOfBirth confirmation modal by setting the state.form.dateOfBirth.confirmedAge value to null,
	 * unless the confirmedAge value is 'true'. In that case, no state change is needed.
	 */
	closeConfirmDob = () => {
		if(!this.state.form.dateOfBirth.confirmedAge){
			let updatedForm = Object.assign({}, this.state.form);
			updatedForm.dateOfBirth.confirmedAge = null;
			this.setState({form: updatedForm, dobConfirmationValue: null});
		}
	}

	/**
	 * Update state when a new value is entered into the Date of Birth confirmation popup
	 */
	handleConfirmDobUpdate = (date) => {
		this.setState({
			dobConfirmationValue: date
		});
	}

	/**
	 * Map old shipping method text to new text.
	 *
	 * The shipping method text has changed but we still need to map old values to new values.
	 * Check for specific words in the order's shipping method and return the new text for that method.
	 * Example: Old 'FedEx Ground - $14.99' -> New 'FedEx Ground'
	 * @param gearOrder The order object, containing the initial shipping method text
	 */
	mapOrderShippingMethod = (gearOrder) => {
		let shippingMethod = this.props.gearOrder.shippingMethod || (this.props.gearOrder.containsDropShipRequisition ? "FedEx Ground" : null);
		if (shippingMethod) {
			if (shippingMethod.indexOf('Ground') > -1) {
				shippingMethod = this.shippingMethods.GROUND;
			} else if (shippingMethod.indexOf('Second') > -1) {
				shippingMethod = this.shippingMethods.SECOND_DAY;
			} else if (shippingMethod.indexOf('Overnight') > -1) {
				shippingMethod = this.shippingMethods.OVERNIGHT;
			} else if (shippingMethod.indexOf('Smart') > -1) {
				shippingMethod = this.shippingMethods.SMART_POST;
			} 
		}

		return shippingMethod;
	}
	
	render() {
		var matchingRows = [];
		var customerType = this.props.userInfo.type;
		if (this.state.matchingPatients && Array.isArray(this.state.matchingPatients) ) {
			matchingRows = this.state.matchingPatients.map((patient, index) => <PatientMatch patient={patient} select={(o) => this.selectPatient(o)} key={"patient_match_" + index} matchKey={"patient_match_" + index} selectedPatientMatchKey={this.state.selectedPatientMatchKey}/>);
		}
		const patientInfo = this.state.patientInfo || {};

		// Only show Responsible Party section when it is required (patient is minor and order is being activated)
		const responsiblePartyRequiredFlag = (!this.props.gearOrder.containsDropShipRequisition || this.props.gearOrder.dataConfirmed) && this.state.isMinor;
		const fullRegistrationRequired = this.props.gearOrder.containsDropShipRequisition || this.props.gearOrder.containsCovidRegistration || customerType === "prc" || this.props.gearOrder.physicianInTheLoop;

		// Highlight the Smart Post disclaimer until a PO Box choice has been made
		const potentialPoBox =
			this.props.gearOrder.containsDropShipRequisition &&
			this.state.poBox !== false &&
			this.hasPOBox(this.state.form.address1.value, this.state.form.address2.value);

		// Is this order for a Government payor (Medicare/Tricare)
		const isGovernmentOrder = isGovernmentPayorOrder(this.props.gearOrder);		
		const employerLabel = this.state.employmentStatus === 'Student' ? 'School ' : 'Employer';

		// Consider the order to be international if the req layout is not domestic OR if the selected country is not "United States"
		const reqLayoutId = this.props.gearOrder.practitioner?.office?.reqLayoutId ?? 0;
		const isInternational = (reqLayoutId !== 0 && reqLayoutId !== 2) || (this.state.form.country?.value && this.state.form.country.value !== 'United States');

		const shippingToCanada = this.state.form?.country?.value?.toUpperCase() === 'CANADA' || isCanadianClient(this.props.gearOrder);

		const inlineEditing = !!this.props.editRef;

		return (
			<div>
				{!inlineEditing && (
					<div className="row">
						<div className="col-md-12">
							<h2>Patient Information</h2>
							{this.state.pageLocked &&
								<AccessionedOrderAlert />
							}
							{(!this.state.pageLocked && this.props.gearOrder.containsDropShipRequisition) &&
								<AlertMessage type="info">
									<p>
										This order includes collection packs that will be shipped to the patient. 
										Please provide the patient information below to ship the order to the patient.
									</p>
								</AlertMessage>
							}
							{(isGovernmentOrder && this.props.userInfo.type === 'myGDX') && 
								<MedicareOrderAlert />
							}
						</div>
					</div>
				)}
				<form onSubmit={this.handleSubmit} autoComplete={this.props.userInfo.type === 'prc' ? "on" : "new-password"} noValidate>
					<div className="row grid-space-20">
						<div className="col-md-12 col-lg-12">
							<AlertMessage display={this.state.showError === true} type="danger">
								{typeof this.state.errorMessage === "string" && <strong>{this.state.errorMessage}</strong>}
								{Array.isArray(this.state.errorMessage) &&
									<ul>
										{this.state.errorMessage.map((key, index) => {
												let message = "";
												switch (key) {
													case "shipping.practitioner.country.mismatch":
														message = "The shipping country must match the practitioner country. Please provide a " + this.props.gearOrder.practitioner.office.address.country + " address.";
														break;
													case "ordering.restricted.found":
														message = "The panel(s) selected may not be ordered in this state.";
														break;
													default:
														message = "We're sorry, an unexpected error has occurred. Please call us at 800-522-4762.";
														break;
												}
												return <li key={"msg_" + key}>{message}</li>;
											})
										}
									</ul>
								}
							</AlertMessage>
							<div>
								<div className="form-group has-feedback">
									{(!this.state.pageConfirmed && customerType !== 'prc') && (
										<>
											<div className="row">
												<div className="form-group col-md-12" hidden={customerType === 'prc'}>
													<h4>Patient</h4>
													<div className="separator-2"></div>
													<span hidden={customerType === 'prc'}>
														To find information on an existing patient, search by last name. You may include the patient's first name and/or date of birth to narrow your results.
													<span hidden={this.props.gearOrder.practitioner.lkCloudSiteServiceKey == null}>
															&nbsp;Alternatively, you may look up a patient by chart number.
													</span>
													&nbsp;If no patients are found, please provide your patient's information below.  Please note the social security number is optional, but required to access online reports.
												</span>
												</div>
											</div>
											<div className="row">
												<div className="form-group col-md-12" hidden={!this.state.searchTimeout}>
													<div className="alert alert-warning" role="alert">
														Searching for patients is taking longer than expected. If no patients are found, please contact Genova or enter patient information below.
													</div>
												</div>
											</div>
											<div className="row">
												<div className="form-group col-md-7" hidden={customerType==='prc'}>
													<div className="input-group">
														<input type="text" className="form-control" id="patient-query" maxLength="100" placeholder="Search patients by name and date of birth e.g. 'Smith' or 'Jane Smith 1/1/1970'" onKeyPress={this.searchAndLookupKeyPressHandler}></input>
														<span className="input-group-btn">
															<button className="btn btn-primary btn-patient-search" id="btn-patient-search" type="button" onClick={this.searchPatients}>
																<span className="fa fa-search"></span>
															</button>
														</span>
													</div>
												</div>
												<div className="form-group col-md-1 text-center" style={{ padding: "8px" }} hidden={customerType==='prc' || this.props.gearOrder.practitioner.lkCloudSiteServiceKey == null}>
													or
												</div>
												<div className="form-group col-md-4" hidden={customerType==='prc' || this.props.gearOrder.practitioner.lkCloudSiteServiceKey == null}>
													<div className="input-group">
														<input type="text" className="form-control" maxLength="20" id="patient-lookup" placeholder="Look up patient by chart number" onKeyPress={this.searchAndLookupKeyPressHandler}></input>
														<span className="input-group-btn">
															<button className="btn btn-primary btn-patient-search" id="btn-patient-lookup" type="button" onClick={this.lookupPatient}>
																<span className="fa fa-search"></span>
															</button>
														</span>
													</div>
												</div>
											</div>
											<div className="row">
												<div className="col-md-12" hidden={!this.state.noMatchesFound}>
													We're sorry, no patients were found with the information provided. Please enter the patient's information below.
												</div>
											</div>
											<div className="row">
												<div className="col-md-12" hidden={this.state.numMatches < 1} onClick={() => this.toggleMatches()}>
													<span hidden={this.state.showMatches}>
														<i className="fa fa-plus-square"></i>&nbsp;
														We found {this.state.numMatches} existing patient match<span hidden={this.state.numMatches === 1}>es</span>.
														Click to review and import information.
													</span>
													<span hidden={!this.state.showMatches}>
														<i className="fa fa-minus-square"></i>&nbsp;
														We found {this.state.numMatches} existing patient match<span hidden={this.state.numMatches === 1}>es</span>.
														Click an entry to use that patient's information. If the information we have is incomplete, you
														may have to enter some additional information before proceeding.
													</span>
												</div>
											</div>
											<div className="row">
												<div className="col-md-12 table-responsive" style={{"maxHeight":"360px", "overflowY":"auto"}} hidden={!this.state.showMatches || this.state.numMatches < 1}>
													<table className="table table-condensed table-hover">
														<colgroup>
															<col style={{"width": "20px"}} />
															<col/>
															<col style={{"width": "200px"}} />
															<col style={{"width": "100px"}} />
														</colgroup>
														<thead>
															<tr>
																<th></th>
																<th>Name</th>
																<th>Date of Birth</th>
																<th>Source</th>
															</tr>
														</thead>
														<tbody>
															{matchingRows}
														</tbody>
													</table>
												</div>
											</div>
											<div className="space"></div>
										</>
									)}
									<div className="row" id="patient-info">
										<div className={"form-group col-md-4 " + (this.state.form.nameFirst.valid === false ? "has-error" : "")}>
											<div>
												<label className="control-label" htmlFor="patient-nameFirst">First Name<span className="text-danger">*</span></label>
												<input className="form-control patientInfo" name="given-name" id="patient-nameFirst" maxLength="50" type="text"
													defaultValue={patientInfo.nameFirst ? patientInfo.nameFirst : ''} onFocus={() => this.setDirty(true)}
													autoComplete={this.props.userInfo.type === 'prc' ? "given-name" : "new-password"} data-fieldname="nameFirst" onChange={this.handlePatientInfoChange.bind(this, 'nameFirst')}>
												</input>
												{this.state.form.nameFirst.valid === false && <span className="validation-message text-danger">{this.state.form.nameFirst.message}</span> }
											</div>
										</div>
										<div className="form-group col-md-4">
											<div>
												<label className="control-label" htmlFor="patient-nameMiddle">Middle Initial</label>
												<input className="form-control patientInfo" name="additional-name" id="patient-nameMiddle" maxLength="1"
													type="text"
													onFocus={() => this.setDirty(true)}
													defaultValue={patientInfo.nameMiddle ? patientInfo.nameMiddle : ''}
													autoComplete={this.props.userInfo.type === 'prc' ? "additional-name" : "new-password"} data-fieldname="nameMiddle" onChange={this.handlePatientInfoChange.bind(this, 'nameMiddle')}>
												</input>
											</div>
										</div>
										<div className={"form-group col-md-4 " + (this.state.form.nameLast.valid === false ? "has-error" : "")}>
											<div>
												<label className="control-label" htmlFor="patient-nameLast">Last Name<span className="text-danger">*</span></label>
												<input className="form-control patientInfo" name="family-name" id="patient-nameLast" maxLength="50" type="text"
													onFocus={() => this.setDirty(true)}
													defaultValue={patientInfo.nameLast ? patientInfo.nameLast : ''}
													autoComplete={this.props.userInfo.type === 'prc' ? "family-name" : "new-password"} data-fieldname="nameLast" onChange={this.handlePatientInfoChange.bind(this, 'nameLast')}
													disabled={this.state.pageConfirmed}
													title={this.state.pageConfirmed ? 'Last Name cannot be changed after the order has been confirmed' : ''}>
												</input>
												{this.state.form.nameLast.valid === false && <span className="validation-message text-danger">{this.state.form.nameLast.message}</span> }
											</div>
										</div>
									</div>
									<div className="row display-flex">
										<div className={"form-group col-xs-12 col-sm-6 col-md-4 " + (this.state.form.dateOfBirth.valid === false ? "has-error" : "")} style={{zIndex: '10'}}>
											<div>
												<label className="control-label" htmlFor="patient-dateOfBirth">Date Of Birth<span className="text-danger">*</span></label>
												<DateOfBirthInput userInfo={this.props.userInfo} onChange={this.dobHandler} value={this.state.form.dateOfBirth.value} displayDateString={this.state.form.dateOfBirth.valid !== false} displayAge={true} />
												{this.state.form.dateOfBirth.valid === false && <span className="validation-message text-danger">{this.state.form.dateOfBirth.message}</span> }
											</div>
										</div>
										<div className={"form-group " + (this.state.covidRegistration ? "col-xs-12 col-sm-3 col-md-2 " : "col-xs-12 col-sm-4 ") + (this.state.form.gender.valid === false ? "has-error" : "")}>
											{/* Add <br /> to align items with DOB input fields (DOB has extra label text) */}
											<span className="hidden-xs"><br /></span>
											<label className="control-label" htmlFor="patientGender">Sex<span className="text-danger">*</span></label>
											<div className="radio">
												<label className="radio-inline">
													<input id="patientGenderMale" name="gender" type="radio" value="M" defaultChecked={patientInfo.gender === 'M'} onFocus={() => this.setDirty(true)} onChange={this.handlePatientInfoChange.bind(this, 'gender')}/> Male
												</label>
												<label className="radio-inline">
													<input id="patientGenderFemale" name="gender" type="radio" value="F" defaultChecked={patientInfo.gender === 'F'} onFocus={() => this.setDirty(true)} onChange={this.handlePatientInfoChange.bind(this, 'gender')}/> Female
												</label>
											</div>
											{this.state.form.gender.valid === false && <span className="validation-message text-danger">{this.state.form.gender.message}</span> }
										</div>
										{(!isInternational && !this.props.gearOrder.physicianInTheLoop) && (
											<>
												<div className={"form-group " + (this.state.covidRegistration ? "col-xs-6 col-md-3 " : "col-xs-12 col-md-4 ") + (this.state.form.ssn.valid === false ? "has-error" : "")}>
													{/* Add <br /> to align items with DOB input fields (DOB has extra label text) */}
													<span className="hidden-xs hidden-sm"><br /></span>
													<label className="control-label" htmlFor="patient-ssn">Social Security #
														{this.state.covidRegistration && <br className="visible-md" />}
														<FieldLevelHelp helpText="Patients who enter their social security number will have access to online reports."
															linkText="why we ask" />
													</label>
													<input className="form-control patientInfo" name="patientInfo" id="patient-ssn"
														maxLength="50" type="text" 
														value={this.state.patientInfo && this.state.patientInfo.ssn ? this.state.patientInfo.ssn : ''}
														onChange={this.handlePatientInfoChange.bind(this, 'ssn')}
														pattern="^\d{3}-\d{2}-\d{4}$"
														title="###-##-####"
														onFocus={() => this.setDirty(true)}
														autoComplete={this.props.userInfo.type === 'prc' ? "ssn" : "new-password"}
														placeholder="###-##-####">
													</input>
													{this.state.form.ssn.valid === false && <span className="validation-message text-danger">{this.state.form.ssn.message}</span> }
												</div>
												<div className={"form-group " + (this.state.covidRegistration ? "col-xs-6 col-md-3 " : "hidden ")+(this.state.form.driverLicenseNumber.valid === false ? "has-error" : "") }>
													{/* Add <br /> to align items with DOB input fields (DOB has extra label text) */}
													<span className="hidden-xs hidden-sm hidden-lg"><br /></span>
													<label className="control-label" htmlFor="patient-ssn">Driver's License Number / State ID Number: </label>
													<input className="form-control patientInfo" name="patientInfo" id="patient-driverLicenseNumber"
														maxLength="20" type="text" 
														value={this.state.patientInfo && this.state.patientInfo.driverLicenseNumber ? this.state.patientInfo.driverLicenseNumber : ''}
														onChange={this.handlePatientInfoChange.bind(this, 'driverLicenseNumber')}
														onFocus={() => this.setDirty(true)}
														autoComplete={this.props.userInfo.type === 'prc' ? "drivers-license" : "new-password"}>
													</input>
													{this.state.form.driverLicenseNumber.valid === false && <span className="validation-message text-danger">{this.state.form.driverLicenseNumber.message}</span> }
												</div>
											</>
										)}
									</div>
									{this.state.nutritionalAgeRestriction && (
										<div className="row">
											<div className="col-md-12">
												<AlertMessage type="danger" additionalCssClass="mt-0">
													<p><strong>Nutritional testing is not available for patients less than 2 years of age.</strong></p>
												</AlertMessage>
											</div>
										</div>
									)}
									<div className="row">
										<div className={"form-group col-md-4 " + (this.state.form.email.valid === false ? "has-error" : "")}>
											<div>
												<label className="control-label" htmlFor="patient-email">Email Address<span className={"text-danger " + (fullRegistrationRequired ? "" : "hidden")}>*</span>
												</label>
												<input className="form-control patientInfo" name="email" id="patient-email" maxLength="100" type="email" onFocus={() => this.setDirty(true)}
													defaultValue={patientInfo.email ? patientInfo.email : ''}
													   autoComplete={this.props.userInfo.type === 'prc' ? "email" : "new-password"} onChange={this.handlePatientInfoChange.bind(this, 'email')}>
												</input>
												{this.state.form.email.valid === false && <span className="validation-message text-danger">{this.state.form.email.message}</span> }
											</div>
										</div>
										<div className={"form-group col-md-4 " + (this.state.form.voicePhone.valid === false ? "has-error" : "")}>
											<label className="control-label" htmlFor="patient-phone">Cell Phone<span className={"text-danger " + (fullRegistrationRequired ? "" : "hidden")}>*</span>
												<FieldLevelHelp html="true" helpText="By submitting your cell phone number, you agree to receive automated customer service text messages (e.g., billing and order updates) from Genova Diagnostics. 
														Message frequency varies. Reply HELP for help and STOP to cancel. Message and data rates may apply. View <a target='_blank' href='./terms-and-conditions'>Terms and Conditions</a> and 
														<a target='_blank' href='./privacy'>Privacy</a> policies."
														linkText="why we ask" />
											</label>
											<PhoneInput
												defaultCountry="US"
												value={this.state.form.voicePhone?.value}
												onChange={this.handleShippingChange.bind(this, 'voicePhone')}
												className="form-control"
												name="tel-national"
												autoComplete={this.props.userInfo.type === 'prc' ? "tel-national" : "new-password"} />
											{this.state.form.voicePhone.valid === false && <span className="validation-message text-danger">{this.state.form.voicePhone.message}</span> }
										</div>
										<div className="form-group col-md-4">
											<label className="control-label" htmlFor="patient-alternate-phone">Alternate Phone</label>
											<PhoneInput
												defaultCountry="US"
												value={this.state.form.voicalternatePhoneePhone?.value}
												onChange={this.handleShippingChange.bind(this, 'alternatePhone')}
												className="form-control"
												autoComplete="new-password" />
										</div>
									</div>
									{customerType === 'prc' && (
										<div className="row">
											<div className="form-group col-xs-12 pl-10"><h4>Communication Preferences</h4>
												<div className="checkbox">
													<label>
														<input className="patientInfo" type="checkbox" name="patientInfo" id="patient-marketingOptIn" defaultChecked={patientInfo.marketingOptIn} /><small>I would like to receive relevant reminders and occasional educational content from Genova's marketing department.</small>
													</label>
												</div>
											</div>
										</div>
									)}
									<div className="row">
										<div className={"form-group col-md-4 " + (this.state.form.race.valid === false ? "has-error" : "")}>
											<label className="control-label" htmlFor="patient-race">Race{this.state.covidRegistration && <span className="text-danger">*</span>}</label>
											<select className="form-control patientInfo" name="patientInfo" id="patient-race"
													value={this.state.patientInfo && this.state.patientInfo.race ? this.state.patientInfo.race : ''}
													onChange={this.handlePatientInfoChange.bind(this, 'race')}
													onFocus={() => this.setDirty(true)} 
													disabled={this.state.pageLocked}>
												<option value=""></option>
												<option value="American Indian/Alaskan Native">American Indian/Alaskan Native</option>
										        <option value="Asian">Asian</option>
										        <option value="Black/African-American">Black/African-American</option>
										        <option value="Native Hawaiian/Pacific Islander">Native Hawaiian/Pacific Islander</option>
										        <option value="White">White</option>
										        <option value="Multiracial">Multiracial</option>
										        <option value="Other">Other</option>
										        <option value="Unknown">Unknown</option>
											</select>
											{this.state.form.race.valid === false && <span className="validation-message text-danger">{this.state.form.race.message}</span> }
										</div>
										<div className={"form-group col-md-4 " + (this.state.form.ethnicity.valid === false ? "has-error" : "")}>
											<label className="control-label" htmlFor="patient-ethnicity">Ethnicity{this.state.covidRegistration && <span className="text-danger">*</span>}</label>
											<select className="form-control patientInfo" name="patientInfo" id="patient-ethnicity"
													value={this.state.patientInfo && this.state.patientInfo.ethnicity ? this.state.patientInfo.ethnicity : ''}
													onChange={this.handlePatientInfoChange.bind(this, 'ethnicity')}
													onFocus={() => this.setDirty(true)}
													disabled={this.state.pageLocked}>
												<option value=""></option>
												<option value="Hispanic">Hispanic</option>
										        <option value="Non-Hispanic">Non-Hispanic</option>
										        <option value="Other">Other</option>
										        <option value="Unknown">Unknown</option>
											</select>
											{this.state.form.ethnicity.valid === false && <span className="validation-message text-danger">{this.state.form.ethnicity.message}</span> }
										</div>
										<div className="form-group col-md-4" hidden={this.props.gearOrder.practitioner.lkCloudSiteServiceKey == null || customerType==='prc'}>
											<div>
												<label className="control-label" htmlFor="patient-chartNumber">Chart Number</label>
												<input className="form-control patientInfo" name="patientInfo" id="patient-chartNumber" maxLength="7"
													type="text"
													onFocus={() => this.setDirty(true)}
													defaultValue={patientInfo.chartNumber ? patientInfo.chartNumber : ''}
													autoComplete="new-password"
													onChange={this.handlePatientInfoChange.bind(this, 'chartNumber')}>
												</input>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div title={this.state.addressLocked ? 'Changes are not allowed after the order has been confirmed for shipping': ''}>
								<div className="row">
									<div className="col-md-12">
										<div className="space"></div>
										<h4>Mailing Address</h4>
										<div className="separator-2"></div>
									</div>
								</div>

								<div className="row">
									<AddressInputForm
										form={this.state.form}
										fullRegistrationRequired={fullRegistrationRequired}
										isInternational={isInternational}
										covidRegistration={this.state.covidRegistration}
										onChangeHandlers={{
											city: this.handleShippingChange.bind(this, 'city'),
											state: this.handleShippingChange.bind(this, 'state'),
											address1: this.handleShippingChange.bind(this, 'address1'),
											address2: this.handleShippingChange.bind(this, 'address2'),
											zipCode: this.handleShippingChange.bind(this, 'zipCode'),
											country: this.handleShippingChange.bind(this, 'country'),
											county: this.handleShippingChange.bind(this, 'county')
										}}
										handleShippingChange={this.handleShippingChange.bind(this)}
										physicianInTheLoop={this.props.gearOrder.physicianInTheLoop}
										addressLookupEnabled={true}
										userInfo={this.props.userInfo}
									/>
								</div>

								{this.state.invalidPhysicianInTheLoopState && (
									<div className="row">
										<div className="col-xs-12">
											<AlertMessage type="danger" additionalCssClass="mb-0">
												<p><strong>Because of legal restrictions, tests are not able to be ordered from your state.</strong></p>
											</AlertMessage>
										</div>
									</div>
								)}

								{(this.props.gearOrder.containsDropShipRequisition && this.props.userInfo.type === 'myGDX' && !shippingToCanada ) && 
									<div className="row space-top">
										<div className="col-md-12">
										<h4>Shipping Method</h4>
										<div className="separator-2"></div>
											<div className={"form-group " + (false && this.state.form.shippingMethod.valid === false ? "has-error" : "")}>
													<ShippingMethodSelection
														gearOrder={this.props.gearOrder}
														shippingMethod={this.state.form.shippingMethod.value}
														setShippingMethod={this.setFormValue}
														isDisabledInputs={this.state.addressLocked || !!this.props.gearOrder?.expeditedShippingPayment?.id}
														displaySmartPost={true}
														isPoBox={this.state.poBox}
														isPotentialPoBox={potentialPoBox}
														userInfo={this.props.userInfo}
													/>
												{false && this.state.form.shippingMethod.valid === false && <div className="validation-message text-danger">{this.state.form.shippingMethod.message}</div>}
											</div>
										</div>
									</div>
								}

							</div>
							{!!this.state.isMinor && (
								<>
									<div className="row">
										<div className="col-md-12">
											<div className="space"></div>
											<h4>Responsible Party - <small>Other legal guardian <span hidden={!this.state.isMinor}> must sign since patient is a minor child </span> </small></h4>
											<div className="separator-2"></div>
										</div>
									</div>
									<div className="row">
										<div className={"form-group col-md-4 " + (this.state.form.responsibleNameFirst.valid === false ? "has-error" : "")}>
											<label className="control-label" htmlFor="patient-responsibleNameFirst">First Name{responsiblePartyRequiredFlag && <span className="text-danger">*</span>}</label>
											<input className="form-control patientInfo" name="patientInfo" id="patient-responsibleNameFirst"
												maxLength="50" type="text"
												value={this.state.form.responsibleNameFirst?.value || ''}
												onChange={this.handlePatientInfoChange.bind(this, 'responsibleNameFirst')}
												onFocus={() => this.setDirty(true)}
												autoComplete="new-password">
											</input>
											{this.state.form.responsibleNameFirst.valid === false && <span className="validation-message text-danger">{this.state.form.responsibleNameFirst.message}</span> }
										</div>
										<div className="form-group col-md-4">
											<label className="control-label" htmlFor="patient-responsibleNameMiddle">Middle Initial</label>
											<input className="form-control patientInfo" name="patientInfo" id="patient-responsibleNameMiddle" maxLength="1"
												type="text" value={this.state.form.responsibleNameMiddle?.value || ''}
												onChange={this.handlePatientInfoChange.bind(this, 'responsibleNameMiddle')}
												onFocus={() => this.setDirty(true)}
												autoComplete="new-password">
											</input>
										</div>
										<div className={"form-group col-md-4 " + (this.state.form.responsibleNameLast.valid === false ? "has-error" : "")}>
											<label className="control-label" htmlFor="patient-responsibleNameLast">Last Name{responsiblePartyRequiredFlag && <span className="text-danger">*</span>}</label>
											<input className="form-control patientInfo" name="patientInfo" id="patient-responsibleNameLast"
												maxLength="50" type="text" 
												value={this.state.form.responsibleNameLast?.value || ''}
												onChange={this.handlePatientInfoChange.bind(this, 'responsibleNameLast')}
												onFocus={() => this.setDirty(true)}
												autoComplete="new-password">
											</input>
											{this.state.form.responsibleNameLast.valid === false && <span className="validation-message text-danger">{this.state.form.responsibleNameLast.message}</span> }
										</div>
									</div>
								</>
							)}
							<div hidden={!this.state.employerRequired}>
								<div className="row">
									<div className="col-md-12 alert alert-info">
										<span >Your state requires Genova to capture the following information.</span>
									</div>
								</div>
								<div className="row">
								<div className={"form-group col-md-6 " + (this.state.form.employmentStatus.valid === false ? "has-error" : "")}>
									<label className="control-label" htmlFor="employmentStatus">Employment Status{this.state.employerRequiredFlag && <span className="text-danger">*</span>}</label>
									<div className="radio">
										<label className="radio-inline">
											<input id="patient-employed" name="employmentStatus" type="radio" value="Employed" checked={this.state.employmentStatus && this.state.employmentStatus === 'Employed'} onFocus={() => this.setDirty(true)} onChange={this.handleEmploymentStatusChange.bind(this, 'employmentStatus')}/> Employed
										</label>	
										<label className="radio-inline">
											<input id="patient-student" name="employmentStatus" type="radio" value="Student" checked={this.state.employmentStatus && this.state.employmentStatus === 'Student'} onFocus={() => this.setDirty(true)} onChange={this.handleEmploymentStatusChange.bind(this, 'employmentStatus')}/> Student
										</label>
										<label className="radio-inline">
											<input id="patient-retired" name="employmentStatus" type="radio" value="Retired" checked={this.state.employmentStatus && this.state.employmentStatus === 'Retired'} onFocus={() => this.setDirty(true)} onChange={this.handleEmploymentStatusChange.bind(this, 'employmentStatus')}/> Retired 
										</label>
										<label className="radio-inline">
											<input id="patient-unemployed" name="employmentStatus" type="radio" value="Unemployed" checked={this.state.employmentStatus && this.state.employmentStatus === 'Unemployed'} onFocus={() => this.setDirty(true)} onChange={this.handleEmploymentStatusChange.bind(this, 'employmentStatus')}/> Unemployed 
										</label>
									</div>
									{this.state.form.employmentStatus.valid === false && <span className="validation-message text-danger">{this.state.form.employmentStatus.message}</span> }
								</div>
								</div>
							<div className={this.state.employmentStatus && (this.state.employmentStatus === 'Unemployed' || this.state.employmentStatus === 'Retired') ? 'hidden' : ''}> 
								  { this.state.employmentStatus === 'Employed' && 
									  <div className="row">
										<div className={"form-group col-md-6 " + (this.state.form.occupation.valid === false ? "has-error " : "") + (this.state.employmentStatus === 'Employed' ? '' : 'hidden')}>
										<label className="control-label" htmlFor="patient-occupation">Occupation{this.state.employerRequiredFlag && <span className="text-danger">*</span>}</label>
										<input className="form-control patientInfo" name="patientInfo" id="patient-occupation"
											maxLength="50" type="text" 
											disabled={!this.state.employerRequired}
											value={this.state.patientInfo && this.state.patientInfo.occupation ? this.state.patientInfo.occupation : ''}
											onChange={this.handlePatientInfoChange.bind(this, 'occupation')}
											onFocus={() => this.setDirty(true)}
											autoComplete="new-password">
										</input>
										{this.state.form.occupation.valid === false && <span className="validation-message text-danger">{this.state.form.occupation.message}</span> }
										</div>
										<div className={"form-group col-md-6 " + (this.state.form.employer.valid === false ? "has-error" : "")}>
										<label className="control-label" htmlFor="patient-employer">{employerLabel} {this.state.employerRequiredFlag && <span className="text-danger">*</span>}</label>
										<input className="form-control patientInfo" name="patientInfo" id="patient-employer"
											maxLength="50" type="text"
											disabled={!this.state.employerRequired}
											value={this.state.patientInfo && this.state.patientInfo.employer ? this.state.patientInfo.employer : ''}
											onChange={this.handlePatientInfoChange.bind(this, 'employer')}
											onFocus={() => this.setDirty(true)}
											autoComplete="new-password">
										</input>
										{this.state.form.employer.valid === false && <span className="validation-message text-danger">{this.state.form.employer.message}</span> }
										</div>
									</div>
									}
									{ this.state.employmentStatus === 'Student' && 
										<div className="row">
										  <div className={"form-group col-md-6 " + (this.state.form.employer.valid === false ? "has-error" : "")}>
											<label className="control-label" htmlFor="patient-employer">{employerLabel} {this.state.employerRequiredFlag && <span className="text-danger">*</span>}</label>
											<input className="form-control patientInfo" name="patientInfo" id="patient-employer"
												maxLength="50" type="text"
												disabled={!this.state.employerRequired}
												value={this.state.patientInfo && this.state.patientInfo.employer ? this.state.patientInfo.employer : ''}
												onChange={this.handlePatientInfoChange.bind(this, 'employer')}
												onFocus={() => this.setDirty(true)}
												autoComplete="new-password">
											</input>
											{this.state.form.employer.valid === false && <span className="validation-message text-danger">{this.state.form.employer.message}</span> }
										  </div>	
										  <div className={"form-group col-md-6 " + (this.state.form.employerSchoolDistrict.valid === false ? "has-error " : "") + (this.state.patientInfo && this.state.patientInfo.occupation && this.state.patientInfo.occupation === 'Student' &&  this.state.covidRegistration  && this.state.shippingAddress.state.toUpperCase() === 'NY'? '' : 'hidden')}>
											<label className="control-label" htmlFor="employer-schoolDistrict">School District{this.state.patientInfo && this.state.patientInfo.occupation && this.state.patientInfo.occupation === 'Student' && this.state.employerRequiredFlag && this.state.shippingAddress.state && this.state.shippingAddress.state.toUpperCase() === 'NY' && <span className="text-danger">*</span>}</label>
											<input className="form-control" name="employerAddress" id="employer-schoolDistrict"
												maxLength="50" type="text" 
													disabled={!this.state.employerRequired}
												value={this.state.patientInfo && this.state.employerAddress && this.state.employerAddress.schoolDistrict ? this.state.employerAddress.schoolDistrict : ''}
												onChange={this.handleEmployerAddChange.bind(this, 'schoolDistrict')}
												autoComplete="new-password">
											</input>
											{this.state.form.employerSchoolDistrict.valid === false && <span className="validation-message text-danger">{this.state.form.employerSchoolDistrict.message}</span> }
										  </div>
										</div>
									}	
									<div className="row">
									<div className={"form-group col-md-6 " + (this.state.form.employerAddress1.valid === false ? "has-error" : "")}>
										<label className="control-label" htmlFor="employer-address1">{employerLabel} Address 1{this.state.employerRequiredFlag && <span className="text-danger">*</span>}</label>
										<input className="form-control" name="employerAddress" id="employer-address1"
											maxLength="50" type="text"
											disabled={!this.state.employerRequired}
											value={this.state.employerAddress && this.state.employerAddress.address1 ? this.state.employerAddress.address1 : ''}
											onChange={this.handleEmployerAddChange.bind(this, 'address1')}
											autoComplete="new-password">
										</input>
										{this.state.form.employerAddress1.valid === false && <span className="validation-message text-danger">{this.state.form.employerAddress1.message}</span> }
									</div>
									<div className="form-group col-md-6">
										<label className="control-label" htmlFor="employer-address2">{employerLabel} Address 2</label>
										<input className="form-control" name="employerAddress" id="employer-address2"
											maxLength="50" type="text" disabled={!this.state.employerRequired}
											value={this.state.employerAddress && this.state.employerAddress.address2 ? this.state.employerAddress.address2 : ''}
											onChange={this.handleEmployerAddChange.bind(this, 'address2')}
											autoComplete="new-password">
										</input>
									</div>
								</div>
								<div className="row">
									<div className={"form-group col-md-3 " + (this.state.form.employerCity.valid === false ? "has-error" : "")}>
										<label className="control-label" htmlFor="employer-city">{employerLabel} City{this.state.employerRequiredFlag && <span className="text-danger">*</span>}</label>
										<input className="form-control" name="employerAddress" id="employer-city"
											maxLength="50" type="text"
											disabled={!this.state.employerRequired}
											value={this.state.employerAddress && this.state.employerAddress.city ? this.state.employerAddress.city : ''}
											onChange={this.handleEmployerAddChange.bind(this, 'city')}
											autoComplete="new-password">
										</input>
										{this.state.form.employerCity.valid === false && <span className="validation-message text-danger">{this.state.form.employerCity.message}</span> }
									</div>
									<div className={"form-group col-md-3 " + (this.state.form.employerState.valid === false ? "has-error" : "")}>
										<label className="control-label" htmlFor="employer-state">{employerLabel} State{this.state.employerRequiredFlag && <span className="text-danger">*</span>}</label>
										<input className="form-control" name="employerAddress" id="employer-state" style={{"paddingLeft": "5px", "paddingRight": "5px"}}
											list="states" maxLength="2" pattern={this.validStates}
											title="Enter a valid 2 character state abbreviaton." type="text"
											disabled={!this.state.employerRequired}
											value={this.state.employerAddress && this.state.employerAddress.state ? this.state.employerAddress.state : ''}
											onChange={this.handleEmployerAddChange.bind(this, 'state')}
											autoComplete="new-password">
										</input>
										{this.state.form.employerState.valid === false && <span className="validation-message text-danger">{this.state.form.employerState.message}</span> }
									</div>
									<div className={"form-group col-md-3 " + (this.state.form.employerZipCode.valid === false ? "has-error" : "")}>
										<label className="control-label" htmlFor="employer-zipCode">{employerLabel} Zip Code{this.state.employerRequiredFlag && <span className="text-danger">*</span>}</label>
										<input className="form-control" name="employerAddress" id="employer-zipCode"
											maxLength="5" type="text"
											disabled={!this.state.employerRequired}
											value={this.state.employerAddress && this.state.employerAddress.zipCode ? this.state.employerAddress.zipCode : ''}
											onChange={this.handleEmployerAddChange.bind(this, 'zipCode')}
											autoComplete="new-password">
										</input>
										{this.state.form.employerZipCode.valid === false && <span className="validation-message text-danger">{this.state.form.employerZipCode.message}</span> }
									</div>
									<div className={"form-group col-md-3 " + (this.state.form.employerVoicePhone.valid === false ? "has-error" : "")}>
									<label className="control-label" htmlFor="employer-voicePhone">{employerLabel} Phone{this.state.employerRequiredFlag && <span className="text-danger">*</span>}</label>
									<PhoneInput
										defaultCountry="US"
										value={this.state.form.employerVoicePhone?.value}
										onChange={this.handleEmployerAddChange.bind(this, 'voicePhone')}
										className="form-control" name="employerAddress" id="employer-voicePhone"
										autoComplete="new-password" />
									{this.state.form.employerVoicePhone.valid === false && <span className="validation-message text-danger">{this.state.form.employerVoicePhone.message}</span> }
								</div>
								</div>
								</div>
							</div>
						</div>
					</div>
					<RequiredFieldDisclaimer />
					{!inlineEditing && (
						<>
							<div className="space"></div>
							<div className="row sticky-bottom">
								<div className="col-md-12">
									<button className="btn btn-white radius btn-sm margin-clear" type="button" onClick={this.goBack}>
										<i className="pl-10 fa fa-arrow-circle-left"></i> &nbsp;
										Back
									</button>
									<button className="btn btn-primary radius btn-sm margin-clear pull-right" type="submit" disabled={this.state.invalidPhysicianInTheLoopState || this.state.nutritionalAgeRestriction}
										title={this.state.nutritionalAgeRestriction ? 'Nutritional testing is not available for patients less than 2 years of age' : this.state.invalidPhysicianInTheLoopState ? 'Testing is not available in your state' : ''}>
										Next
										<i className="pl-10 fa fa-arrow-circle-right"></i>
									</button>
								</div>
							</div>
						</>
					)}
				</form>
				{this.state.showPoBoxDialog && <PostOfficeBoxPrompt address={this.state.poBoxConfirmationAddress} affirmPoBox={this.affirmPoBox} denyPoBox={this.denyPoBox} modalHidden={() => this.setState({ showPoBoxDialog: false })} />}
				{(this.state.form.dateOfBirth.confirmedAge === false) && (
					<Modal 
						title="Please Confirm Patient's Date Of Birth" 
						confirmAction="Confirm" 
						onSave={this.confirmDob}
						modalHidden={this.closeConfirmDob}>
						<div className="row">
							<div className="form-group col-xs-4" style={{zIndex: '10'}}>
								<div>
									<label className="control-label" htmlFor="patient-dateOfBirth">Date Of Birth</label>
									<DateOfBirthInput userInfo={this.props.userInfo} onChange={this.handleConfirmDobUpdate} value={this.state.form.dateOfBirth.value} displayDateString={true} displayAge={true} />
								</div>
							</div>
						</div>
					</Modal>
					)}
			</div>
		);
	}
}

// wrap the component in the workflow HOC to get access to common workflow logic
export default withWorkflow(PatientInfo);